import React from 'react';
import { useUser } from '@lore/auth';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useDialogLauncher from '../../../dialogs-routable/_hooks/useDialogLauncher';
import { SolidButton } from '../../../components/Button';
import GrayOutlineButton from '../../../components/Button/OutlineButton.gray';
import ComposableProjectHeader from '../../../components_cards/ComposableProjectHeader';
import DividerCard from '../../../components/DividerCard';
import TagRow from '../../../components_cards/tags/TagRow';
import ProjectTag from '../../../components_cards/tags/ProjectTag';
import ExpiredTag from '../../../components_cards/tags/_resource/ExpiredTag';
import CreatorTag from '../../../components_cards/tags/CreatorTag';
import Invitations from '../../my-past/EventCreated/Invitations';
import Questions from '../../my-past/ProjectCreated/Questions';

export default function ExpiredProject(props) {
  const { project } = props;

  const currentUser = useUser();
  const launch = useDialogLauncher();

  const to = currentUser.id === project.data.creatorId ? `/manage` : `/view`;

  function onClickManage() {
    launch(DialogManager.ProjectManage.Config(project.id, to));
  }

  function onClick() {
    launch(DialogManager.ProjectCloseExtend.Config(project.id));
  }

  return (
    <DividerCard>
      <ComposableProjectHeader
        project={project}
        tags={(
          <>
            <TagRow>
              <ProjectTag />
              <CreatorTag />
              <ExpiredTag resource={project} />
            </TagRow>
            <Questions project={project} />
          </>
        )}
        showTags={false}
        showCreator={false}
      />
      <div className="w-full bg-cs-gray-50 py-4 px-4 flex justify-between items-center">
        <div />
        <div className="flex flex-wrap gap-2">
          <GrayOutlineButton
            onClick={onClickManage}
            label="Manage project"
          />
          <SolidButton
            onClick={onClick}
            label="Close or extend date"
          />
        </div>
      </div>
    </DividerCard>
  );
}
